export type AppointmentType = 'visita_ocular' | 'firma_contrato'

export interface AppointmentConfig {
  type: AppointmentType
  title: string
  subtitle: string
  description: string
  icon: string
  processSteps: {
    step: number
    text: string
  }[]
  infoAlert: {
    title: string
    description: string
    variant?: 'info' | 'warning'
  }
  buttons: {
    primary: string
    secondary: string
  }
}

export const APPOINTMENT_CONFIGS: Record<AppointmentType, AppointmentConfig> = {
  visita_ocular: {
    type: 'visita_ocular',
    title: 'Agenda tu visita de verificación',
    subtitle:
      'Necesitamos realizar una visita de verificación como parte del proceso de evaluación de tu solicitud.',
    description:
      'Se abrirá una ventana de Calendly donde podrás seleccionar la fecha y hora que mejor te convenga.',
    icon: '📋', // Clipboard para verificación
    processSteps: [
      {
        step: 1,
        text: 'Serás redirigido a Calendly donde podrás elegir la fecha y hora que prefieras',
      },
      {
        step: 2,
        text: 'Recibirás una confirmación por correo electrónico con todos los detalles',
      },
      {
        step: 3,
        text: 'Nuestro equipo realizará la visita en la fecha acordada',
      },
    ],
    infoAlert: {
      title: 'Información importante',
      description:
        'La visita de verificación es un requisito obligatorio para completar tu solicitud. Te recomendamos agendarla lo antes posible para evitar retrasos en el proceso.',
      variant: 'warning',
    },
    buttons: {
      primary: 'Agendar con Calendly',
      secondary: 'Agendar más tarde',
    },
  },
  firma_contrato: {
    type: 'firma_contrato',
    title: 'Agenda tu cita para firmar contrato',
    subtitle:
      'Es momento de firmar tu contrato de arrendamiento. Selecciona la fecha y hora que mejor te convenga.',
    description:
      'Se abrirá una ventana de Calendly donde podrás seleccionar la fecha y hora disponible para acudir a nuestras oficinas.',
    icon: '✍️', // Writing hand para firma
    processSteps: [
      {
        step: 1,
        text: 'Serás redirigido a Calendly donde podrás elegir entre las fechas disponibles',
      },
      {
        step: 2,
        text: 'Recibirás una confirmación con la ubicación de nuestras oficinas',
      },
      {
        step: 3,
        text: 'Acudirás a firmar el contrato en la fecha programada',
      },
    ],
    infoAlert: {
      title: '¡Estás muy cerca!',
      description:
        'Una vez firmado el contrato, podrás comenzar a disfrutar de tu nuevo arrendamiento. Recuerda traer una identificación oficial vigente.',
      variant: 'info',
    },
    buttons: {
      primary: 'Agendar cita para firmar',
      secondary: 'Programar después',
    },
  },
}
